import { Badge, FlexBox } from '@dixa/lib-shared-habla';
import { memo, useMemo } from 'react';
import { shallowEqual } from 'react-redux';

import { useAppSelector } from 'utils/redux/useAppSelector';

type MessagingQueueDetailsProps = {
  queueId: string;
};

export const MessagingQueueDetails = memo(function MessagingQueueDetails({
  queueId,
}: MessagingQueueDetailsProps): JSX.Element {
  const { queues, organizationDefaultQueue } = useAppSelector(
    ({ settings }) => ({
      queues: settings.queues.queues,
      organizationDefaultQueue:
        settings.organization.organization.default_queue,
    }),
    shallowEqual,
  );

  const getQueue = (id: string) => {
    return queues.find((queue) => queue.id === id);
  };

  const queue = useMemo(() => {
    const currentQueue = getQueue(queueId);

    if (currentQueue) {
      return currentQueue;
    }

    const defaultQueue = getQueue(organizationDefaultQueue);

    if (defaultQueue) {
      return defaultQueue;
    }

    return {
      name: 'No default queue set',
      is_archived: false,
      is_default: false,
    };
  }, [queues, queueId, organizationDefaultQueue]);

  return (
    <FlexBox gap="200" alignItems="center">
      {queue.name}

      {queue?.is_archived && (
        <Badge variant="error" size="small">
          Archived
        </Badge>
      )}

      {queue?.is_default && (
        <Badge variant="info" size="small">
          Default
        </Badge>
      )}
    </FlexBox>
  );
});
